<lib-generic-type-ahead-dropdown
    [(selectedItem)]="selectedCompany"
    [displaySelected]="displaySelected"
    placeholder="Add Company"
    (selectedItemChange)="onCompanyChange($event)"
    [(text)]="searchText"
    [source]="source"
    (textChange)="onCompanyTextChanged()"
    [config]="{
        defaultText: 'Add Company',
        itemDisplayKey: 'name',
        itemTemplate: itemTemplate,
        isActive: selectedCompany?.isActive ?? true,
        clearSelection: selectedCompany?.id ? true : false
    }"
    [isReadOnly]="isReadOnly"
    [action]="addCompanyAction"
    [path]="path()"
>
</lib-generic-type-ahead-dropdown>

<ng-template #itemTemplate let-data>
    <div class="item">
        <app-custom-menu-item
            [inputText]="data.inputText"
            [title]="data.object?.name ?? ''"
            [subtitle]="data.object?.abbreviation ?? ''"
        >
        </app-custom-menu-item>
    </div>
</ng-template>
